<app-ehe-layout *ngIf="isMobile" [footer]="false">
	<div class="sso-loader-wrapper">Validating your credentials, don't press back, please wait...</div>
</app-ehe-layout>
